<script lang="ts">
	import { Button } from '@atoms';

	const {
		targets
	}: {
		targets: {
			title: string;
			hash: string;
		}[];
	} = $props();
</script>

<section>
	<ul class="submenu">
		{#each targets as { title, hash }}
			<Button variant="link" class="text:description" href={`#${hash}`}>{title}</Button>
		{/each}
	</ul>
</section>

<style lang="scss">
	section {
		display: none;

		@include pagePadding;
		@include md {
			display: block;
		}
	}

	.submenu {
		display: flex;
		padding: 0;
		margin-bottom: $padding-small;
		border-bottom: $border;
		padding-bottom: $padding-mini;

		:global([data-button]) {
			padding-right: 40px;
			&:hover {
				text-decoration: none;
			}
		}
	}
</style>
